import { createFileRoute } from "@tanstack/react-router";
import { Prose } from "@/components/site/PageHeader";
import { EditablePageShell } from "@/components/site/EditablePageShell";
import { pageQueryOptions } from "@/lib/pages.functions";
import { BUSINESS, ADDRESS_LINES } from "@/lib/business-info";

export const Route = createFileRoute("/legal/privacy")({
  loader: ({ context }) => context.queryClient.ensureQueryData(pageQueryOptions("legal/privacy")),
  head: ({ loaderData }) => ({
    meta: [
      { title: loaderData?.title || "Privacy Policy — Glow Long Golf" },
      { name: "description", content: loaderData?.meta_description || "How Glow Long Golf collects, uses, and protects your personal information." },
      { property: "og:title", content: loaderData?.title || "Privacy Policy — Glow Long Golf" },
      { property: "og:description", content: loaderData?.meta_description || "How Glow Long Golf collects, uses, and protects your personal information." },
      { property: "og:url", content: "https://glowlong.lovable.app/legal/privacy" },
    ],
    links: [{ rel: "canonical", href: "https://glowlong.lovable.app/legal/privacy" }],
  }),
  errorComponent: ({ error }) => <div className="p-8 text-sm text-destructive" role="alert">{error.message}</div>,
  notFoundComponent: () => <div className="p-8 text-sm text-muted-foreground">Not found.</div>,
  component: () => (
    <EditablePageShell slug="legal/privacy" defaults={{ eyebrow: "Legal", title: "Privacy Policy" }}>
      <Prose>
        <p><strong>Last updated:</strong> {new Date().toLocaleDateString()}</p>
        <p>Glow Long Golf ("we", "us") collects only the information needed to operate the store: order data, email addresses you give us, and analytics about how the site is used (subject to your consent).</p>
        <h2>What we collect</h2>
        <ul>
          <li>Contact info you give us (email, phone, shipping address)</li>
          <li>Order and payment metadata (we do not store card numbers — Stripe handles payments)</li>
          <li>Cookies and similar identifiers for analytics and marketing (only with consent)</li>
        </ul>
        <h2>How we use it</h2>
        <p>To fulfill orders, send transactional emails, respond to inquiries, run analytics and marketing (where you've consented), and improve the product.</p>
        <h2>Who sees it</h2>
        <p>Service providers (payments, fulfillment via Amazon, email, analytics). We do not sell personal data.</p>
        <h2>Your choices</h2>
        <p>You can request access, correction, or deletion of your data by emailing us. Use our <a href="/legal/cookies">cookies page</a> to update analytics and marketing preferences.</p>
        <h2>Contact us</h2>
        <p>
          {BUSINESS.name}<br />
          Phone: <a href={`tel:${BUSINESS.phoneHref}`}>{BUSINESS.phone}</a><br />
          Email: <a href={`mailto:${BUSINESS.email}`}>{BUSINESS.email}</a><br />
          {ADDRESS_LINES.map((line) => (
            <span key={line}>{line}<br /></span>
          ))}
        </p>
      </Prose>
    </EditablePageShell>
  ),
});
